// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___s4xs","textarea":"styles_textarea__1hz_U"};